import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../styles/materialButtonStyle";
import FeeTypeSelect from "../../elements/fee/FeeTypeSelect";
import Dropdown from "rc-dropdown";
import MappedServicesFilter from "../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../elements/filter/styledFiter";

const FeeFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("feePage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "percent[gte]": "",
    "percent[lte]": "",
    "constant[gte]": "",
    "constant[lte]": "",
    "max[gte]": "",
    "max[lte]": "",
    "min[gte]": "",
    "min[lte]": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.paymentMethod")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <MappedServicesFilter
              checkedService={filterData["baseFee.service.name"]}
              setCheckedService={data => handleChangeFilterData(data, "baseFee.service.name")}

              checkedPaymentSystem={filterData["baseFee.paymentSystem.name"]}
              setCheckedPaymentSystem={data => handleChangeFilterData(data, "baseFee.paymentSystem.name")}

              checkedCurrency={filterData["baseFee.currency.asset"]}
              setCheckedCurrency={data => handleChangeFilterData(data, "baseFee.currency.asset")}
            />
            <StyledSelectGroup>
              <FeeTypeSelect
                checkedType={filterData["baseFee.type"]}
                setCheckedType={(data) => setFilterData({ ...filterData, "baseFee.type": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.percent")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="percent[gte]">
                {t("filter.percentFrom")}
              </label>
              <DelayInput
                id="percent[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "percent[gte]": event.target.value, page: 1 })}
                name="percent[gte]"
                value={filterData["percent[gte]"]}
                type="number"
                step={0.1}
                min={0}
                max={1}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="percent[lte]">
                {t("filter.percentTo")}
              </label>
              <DelayInput
                id="percent[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "percent[lte]": event.target.value, page: 1 })}
                name="percent[lte]"
                value={filterData["percent[lte]"]}
                type="number"
                step={0.1}
                min={0}
                max={1}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.constant")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="constant[gte]">
                {t("filter.constantFrom")}
              </label>
              <DelayInput
                id="constant[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "constant[gte]": event.target.value, page: 1 })}
                name="constant[gte]"
                value={filterData["constant[gte]"]}
                type="number"
                placeholder={t("filter.example", { value: 20 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="constant[lte]">
                {t("filter.constantTo")}
              </label>
              <DelayInput
                id="constant[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "constant[lte]": event.target.value, page: 1 })}
                name="constant[lte]"
                value={filterData["constant[lte]"]}
                type="number"
                placeholder={t("filter.example", { value: 200 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.min")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="min[gte]">
                {t("filter.minFrom")}
              </label>
              <DelayInput
                id="min[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "min[gte]": event.target.value, page: 1 })}
                name="min[gte]"
                value={filterData["min[gte]"]}
                type="number"
                placeholder={t("filter.example", { value: 20 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="min[lte]">
                {t("filter.minTo")}
              </label>
              <DelayInput
                id="min[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "min[lte]": event.target.value, page: 1 })}
                name="min[lte]"
                value={filterData["min[lte]"]}
                type="number"
                placeholder={t("filter.example", { value: 200 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.max")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="max[gte]">
                {t("filter.maxFrom")}
              </label>
              <DelayInput
                id="max[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "max[gte]": event.target.value, page: 1 })}
                name="max[gte]"
                value={filterData["max[gte]"]}
                type="number"
                placeholder={t("filter.example", { value: 20 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="max[lte]">
                {t("filter.maxTo")}
              </label>
              <DelayInput
                id="max[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "max[lte]": event.target.value, page: 1 })}
                name="max[lte]"
                value={filterData["max[lte]"]}
                type="number"
                placeholder={t("filter.example", { value: 200 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default FeeFilter;